import React, { useState, useEffect } from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { numaraListesiAyristir, numaraListesiPlanla } from './yardimcilar';

// NUMARA LİSTESİYLE DOLDUR (Basım Faz 1, 2026-10-09, kullanıcı isteği): yapıştırılan soru
// numaraları derslere ayrılır, her ders SABİT soru listesi olur (mevcut ders sabitleme yolu)
// → ÖSYM çok testli deneme. Basılamayacak soru nedeniyle listelenir; bağlam çiftinin eksik
// kardeşi tek tıkla eklenir. Numaraların sözü geçen soruları POST /api/sorular/batch getirir.
const TAVAN = 500;

export default function NumaraListesi({ apiUrl, yayineviId, onUygula, onYayineviSec = null, dolgu = null }) {
  const [girdi, setGirdi] = useState('');
  const [sonuc, setSonuc] = useState(null);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  // `alici`: yeniden basım düğmesi yayınevini seçip AYNI anda yeniden ayırır (prop henüz güncellenmedi).
  const ayir = async (metin, alici = yayineviId) => {
    const { nolar, gecersiz } = numaraListesiAyristir(metin, TAVAN);
    setHata('');
    if (nolar.length === 0) {
      setSonuc(null);
      setHata(gecersiz.length ? `Geçerli soru numarası yok: ${gecersiz.join(', ')}` : 'Soru numarası girin (ör. 12, 45, #88 ya da 40100-40110).');
      return;
    }
    if (nolar.length > TAVAN) { setHata(`Tek seferde en çok ${TAVAN} soru (${nolar.length} girildi).`); return; }
    setYukleniyor(true);
    try {
      const token = localStorage.getItem('yks_token');
      const r = await fetch(`${apiUrl}/api/sorular/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({ public_nolar: nolar }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !Array.isArray(d.sorular)) throw new Error(d.hata || `Sorular alınamadı (HTTP ${r.status})`);
      const plan = numaraListesiPlanla(d.sorular, { bulunamayan: d.bulunamayan, yayineviId: alici });
      // Aynı yayınevi yeniden basabilir (2026-10-20, kullanıcı isteği): elenen satılmış sorular alıcıya göre
      // gruplanır; düğme o yayınevini seçer, PDF yeni satış kaydı YAZMAZ (zaten o alıcıda).
      const elenenNo = new Set(plan.elenen.map((e) => e.no));
      const alicilar = new Map();
      d.sorular.forEach((s) => {
        const yv = s.satis && s.satis.yayinevi_id;
        if (!yv || !elenenNo.has(Number(s.public_no))) return;
        if (!alicilar.has(yv)) alicilar.set(yv, { id: yv, ad: s.satis.yayinevi || `#${yv}`, nolar: [] });
        alicilar.get(yv).nolar.push(Number(s.public_no));
      });
      setSonuc({ ...plan, gecersiz, alicilar: [...alicilar.values()] });
      if (plan.dersler.length > 0) onUygula(plan);
    } catch (e) {
      setSonuc(null);
      setHata(e.message || 'Sorular alınamadı');
    }
    setYukleniyor(false);
  };

  // GEÇMİŞTEN YENİDEN BASIM (2026-10-20): Basım geçmişindeki kaydın numaraları kutuya yazılır ve hemen
  // ayrılır; sorular bir alıcıya satılmışsa Basım o alıcıyı seçmiştir (`dolgu.alici`).
  useEffect(() => {
    if (!dolgu) return;
    setGirdi(dolgu.metin);
    ayir(dolgu.metin, dolgu.alici);
  }, [dolgu]);

  // Eksik kardeşleri listede üyesinin hemen arkasına ekler ve yeniden ayırır.
  const kardesleriEkle = () => {
    const ek = new Map(sonuc.eksikKardes.map((e) => [e.no, e.kardesler]));
    const { nolar } = numaraListesiAyristir(girdi, TAVAN);
    const yeni = [];
    nolar.forEach((n) => { yeni.push(n); (ek.get(n) || []).forEach((k) => { if (!nolar.includes(k) && !yeni.includes(k)) yeni.push(k); }); });
    const metin = yeni.join(', ');
    setGirdi(metin);
    ayir(metin);
  };

  const ad = (k) => (DERSLER.find((x) => x.value === k)?.label || k).replace(/^(TYT|AYT)\s+/i, '');
  const elenenGrup = sonuc ? sonuc.elenen.reduce((m, e) => ((m[e.neden] = m[e.neden] || []).push(e.no), m), {}) : {};

  return (
    <details data-numara-liste open={dolgu ? true : undefined} className="rounded-lg border border-sky-200 bg-sky-50/40 px-3 py-2">
      <summary className="cursor-pointer text-[11px] font-bold text-sky-900">
        🔢 Numara listesiyle doldur <span className="font-normal text-sky-700">— soru numaralarını yapıştırın, dersler ve ÖSYM testleri kendiliğinden kurulur</span>
      </summary>
      <div className="mt-2 space-y-2">
        <textarea data-numara-girdi value={girdi} onChange={(e) => setGirdi(e.target.value)} rows={3}
          placeholder="12, 45, #88 · alt alta liste · aralık 40100-40110"
          className="w-full px-2 py-1.5 border border-gray-300 rounded text-xs font-mono" />
        <div className="flex flex-wrap items-center gap-2">
          <button type="button" data-numara-ayir onClick={() => ayir(girdi)} disabled={yukleniyor}
            className="text-xs px-3 py-1 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-700 disabled:opacity-50">
            {yukleniyor ? '⏳ Getiriliyor…' : 'Derslere ayır'}
          </button>
          <span className="text-[10px] text-gray-500">Mevcut ders seçimi listeyle DEĞİŞİR; her ders “🔒 sabit” olur (çözünce havuzdan seçime döner).</span>
        </div>
        {hata && <div data-numara-hata className="text-[11px] text-red-700 font-semibold">{hata}</div>}
        {sonuc && (
          <div data-numara-sonuc className="text-[11px] space-y-1">
            <div className="text-gray-800">
              <strong>{sonuc.toplam}</strong> soru · {sonuc.sinav} · {sonuc.dersler.map((d) => `${ad(d.ders)} ${d.adet}`).join(' · ') || 'basılabilecek soru yok'}
            </div>
            {sonuc.bulunamayan.length > 0 && (
              <div data-numara-uyari="bulunamayan" className="text-amber-800">⚠ Bulunamadı: {sonuc.bulunamayan.map((n) => `#${n}`).join(', ')}</div>
            )}
            {sonuc.gecersiz.length > 0 && (
              <div data-numara-uyari="gecersiz" className="text-amber-800">⚠ Anlaşılmadı: {sonuc.gecersiz.join(', ')}</div>
            )}
            {Object.entries(elenenGrup).map(([neden, nolar]) => (
              <div key={neden} data-numara-uyari="elenen" className="text-red-700">✕ Basılmaz ({neden}): {nolar.map((n) => `#${n}`).join(', ')}</div>
            ))}
            {onYayineviSec && (sonuc.alicilar || []).map((a) => (
              <div key={a.id} data-numara-uyari="yeniden-basim" className="text-purple-800">
                💰 {a.nolar.length} soru <strong>{a.ad}</strong> yayınevine satılmış ({a.nolar.map((n) => `#${n}`).join(', ')})
                {' '}<button type="button" data-yeniden-bas onClick={() => { onYayineviSec({ id: a.id, ad: a.ad }); ayir(girdi, a.id); }}
                  className="ml-1 px-2 py-0.5 rounded bg-white border border-purple-300 font-semibold hover:bg-purple-50">{a.ad} için yeniden bas</button>
              </div>
            ))}
            {sonuc.eksikKardes.length > 0 && (
              <div data-numara-uyari="kardes" className="text-amber-800">
                ⚠ Bağlam çiftinin kardeşi listede yok: {sonuc.eksikKardes.map((e) => `#${e.no} (kardeşi ${e.kardesler.map((k) => `#${k}`).join(', ')})`).join(' · ')}
                {' '}<button type="button" data-kardes-ekle onClick={kardesleriEkle}
                  className="ml-1 px-2 py-0.5 rounded bg-white border border-amber-300 font-semibold hover:bg-amber-50">kardeşleri ekle</button>
              </div>
            )}
          </div>
        )}
      </div>
    </details>
  );
}
